import { all, call, put, takeLatest } from 'redux-saga/effects';
import { fetchClient } from '../utilities/fetchClient';
import ActionTypes from '../actions/actionTypes';
import {
  getEnrolmentStatusSuccess,
  getEnrolmentStatusFailure,
  getMyobLoginUriSuccess,
  getMyobLoginUriFailure,
  myobDisconnectSuccess,
  myobDisconnectFailure,
  getXeroLoginUriSuccess,
  getXeroLoginUriFailure,
  xeroConnectSuccess,
  xeroConnectFailure,
  xeroDisconnectSuccess,
  xeroDisconnectFailure,
} from '../actions/accountingIntegrationActions';
import Env from '../Env';
import Alert from 'constants/alert-messages';
import { addToastAlert } from 'actions/toastAlertActions';
import SURVEYS from '../constants/surveys';

function* getEnrolmentStatus(action) {
  const { grandParentAccountNumber, contractIdentifier } = action.payload;

  const header = {
    'Ocp-Apim-Subscription-Key': Env.getApimKey(),
  };

  try {
    const response = yield call(fetchClient, {
      url: `accounts-api/v1/accounting/${contractIdentifier}/enrolment?grandParentAccountNumber=${grandParentAccountNumber}`,
      method: 'GET',
      headers: header,
      apiServer: Env.getApimBaseUrl(),
    });

    yield put(getEnrolmentStatusSuccess(response));
  } catch {
    yield put(getEnrolmentStatusFailure());
  }
}

function* getMyobLoginUri(action) {
  const { contractIdentifier } = action.payload;

  const header = {
    'Ocp-Apim-Subscription-Key': Env.getApimKey(),
  };

  try {
    const response = yield call(fetchClient, {
      url: `accounts-api/v1/accounting/myob/loginUri?state=${contractIdentifier}`,
      method: 'GET',
      headers: header,
      apiServer: Env.getApimBaseUrl(),
    });

    yield put(getMyobLoginUriSuccess(response));
  } catch {
    yield put(getMyobLoginUriFailure());
  }
}

function* myobDisconnect(action) {
  const { grandparentAccountNumber, contractIdentifier } = action.payload;

  const header = {
    'Ocp-Apim-Subscription-Key': Env.getApimKey(),
  };

  try {
    yield put(addToastAlert(Alert.MYOB_DISCONNECT_LOADING));
    yield call(fetchClient, {
      url: `accounts-api/v1/accounting/myob/${contractIdentifier}/disconnect?grandParentAccountNumber=${grandparentAccountNumber}`,
      method: 'POST',
      headers: header,
      apiServer: Env.getApimBaseUrl(),
    });

    yield put(myobDisconnectSuccess());
    yield put(addToastAlert(Alert.MYOB_DISCONNECT_SUCCESS, 'success'));
  } catch {
    yield put(myobDisconnectFailure());
    yield put(addToastAlert(Alert.MYOB_DISCONNECT_ERROR, 'error'));
  }
}

function* getXeroLoginUri(action) {
  const { state } = action.payload;

  const header = {
    'Ocp-Apim-Subscription-Key': Env.getApimKey(),
  };

  try {
    const response = yield call(fetchClient, {
      url: `accounts-api/v1/accounting/xero/loginUri?state=${state}`,
      method: 'GET',
      headers: header,
      apiServer: Env.getApimBaseUrl(),
    });

    yield put(getXeroLoginUriSuccess(response));
  } catch {
    yield put(getXeroLoginUriFailure());
  }
}

function* xeroConnect(action) {
  const { grandparentAccountNumber, contractIdentifier, authorizationCode } = action.payload;

  const header = {
    'Ocp-Apim-Subscription-Key': Env.getApimKey(),
  };

  try {
    yield call(fetchClient, {
      url: `accounts-api/v1/accounting/xero/${contractIdentifier}/connect?authorizationCode=${authorizationCode}&grandParentAccountNumber=${grandparentAccountNumber}`,
      method: 'POST',
      headers: header,
      apiServer: Env.getApimBaseUrl(),
    });

    yield put(xeroConnectSuccess());
    if (Env.getIsZonkaEnabled() && typeof window._zf === 'function' && SURVEYS.LINKING_EVERYDAY_REWARDS_XERO_MYOB) {
      window._zf('startForm', { 'widgetId': SURVEYS.LINKING_EVERYDAY_REWARDS_XERO_MYOB, 'throttle': 'session' });
    }
  } catch {
    yield put(xeroConnectFailure());
  }
}

function* xeroDisconnect(action) {
  const { grandparentAccountNumber, contractIdentifier } = action.payload;

  const header = {
    'Ocp-Apim-Subscription-Key': Env.getApimKey(),
  };

  try {
    yield put(addToastAlert(Alert.XERO_DISCONNECT_LOADING));
    yield call(fetchClient, {
      url: `accounts-api/v1/accounting/xero/${contractIdentifier}/disconnect?grandParentAccountNumber=${grandparentAccountNumber}`,
      method: 'POST',
      headers: header,
      apiServer: Env.getApimBaseUrl(),
    });

    yield put(xeroDisconnectSuccess());
    yield put(addToastAlert(Alert.XERO_DISCONNECT_SUCCESS, 'success'));
  } catch {
    yield put(xeroDisconnectFailure());
    yield put(addToastAlert(Alert.XERO_DISCONNECT_ERROR, 'error'));
  }
}

export default function* accountingIntegrationSaga() {
  yield all([
    takeLatest(ActionTypes.ACCOUNTING_INTEGRATION.ENROLMENT_STATUS.REQUEST, getEnrolmentStatus),
    takeLatest(ActionTypes.ACCOUNTING_INTEGRATION.MYOB_LOGIN_URI.REQUEST, getMyobLoginUri),
    takeLatest(ActionTypes.ACCOUNTING_INTEGRATION.MYOB_DISCONNECT.REQUEST, myobDisconnect),
    takeLatest(ActionTypes.ACCOUNTING_INTEGRATION.XERO_LOGIN_URI.REQUEST, getXeroLoginUri),
    takeLatest(ActionTypes.ACCOUNTING_INTEGRATION.XERO_CONNECT.REQUEST, xeroConnect),
    takeLatest(ActionTypes.ACCOUNTING_INTEGRATION.XERO_DISCONNECT.REQUEST, xeroDisconnect),
  ]);
}
